import React from 'react';
import PropTypes from 'prop-types';
import ShareModal from './ShareModal';
import './pull-quote.scss';
import { decodeTags, isValid, isText, sendLog } from '../../../../utils';

const PullQuote = ({
  data,
  className,
  standardArticleTracker={},
  fullUrl,
}) => {
  if (!isValid(data)) { return null; }
  const {
    author='', shareButtons=[], articleUrl='', excludeAuthor=false,
  } = data;
  let { bodyText } = data;

  const shareUrl = isText(articleUrl) ? articleUrl : isText(fullUrl) ? fullUrl : null;
  try {
    if (isValid(bodyText)) {
      const encodedBodyData = decodeTags(bodyText);
      bodyText = encodedBodyData;
    }
  } catch (e) {
    sendLog('PullQuote', 'error', 'no body data');
    bodyText = '';
    throw new Error('no body data');
  }
  const quoteClass = excludeAuthor ? 'quote-share no-quote' : 'quote-share show-quote';
  return (
    <div className={className}>
      <div className="social-wrapper">
        <ShareModal buttons={shareButtons} articleUrl={shareUrl} standardArticleTracker={standardArticleTracker} />
      </div>
      <div className="quote-wrapper">
        <div className={quoteClass} dangerouslySetInnerHTML={{ __html: bodyText }} />
          { !excludeAuthor
            && <h6>- {author}</h6>
          }
        </div>
      </div>
  );
};

PullQuote.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
};

export default PullQuote;
